module.exports = __webpack_public_path__ + "images/a20bd47a02f8c29341ab8c93be477b06.png";